import React, { Component, Fragment } from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import SpinnerComponent from '../../../components/SpinnerComponent';
import FormRegistrazioneConsulenteGruppo from './FormRegistrazioneConsulenteGruppo';

import { getGruppo } from '../../../utils/api/gruppi_api';
import { registerConsulente } from '../../../utils/api/consulenti_api';

import validator from 'validator';

import PropTypes from 'prop-types';
import { AUTH_TYPES } from '../../../auth/auth.options';
import { reportApiError, reportError } from '../../../utils/reportApiError';

const styles = {
  root: {
    textAlign: 'center',
    padding: '26px 4px',
  },
  groupName: {
    fontWeight: 600,
  },
  texts: {
    marginBottom: '20px',
  },
};

export default class RegistraConsulenteGruppoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      consulente: {
        id: null,
        email: '',
        nome: '',
        password: '',
        confirmPassword: '',
        cognome: '',
        telefono: '',
        terminiUsoAccettati: '',
        privacyPolicyAccettata: '',
        partitaIva: '',
        codiceSdi: '',
        pec: '',
        gruppoId: '',
        superconsulente: false,
        passwordEnabled: true,
        oauthEnabled: false,
      },
      gruppo: {
        id: null,
        nome: '',
        brand: {
          id: null,
          nome: '',
        },
      },
      validationErrors: {
        email: '',
        password: '',
        confirmPassword: '',
      },
      changesNotSaved: false,
      submitDisabled: true,
      disabledForm: false,
    };
  }

  componentDidMount() {
    this.fetchGruppo();
  }

  fetchGruppo = () => {
    let gruppoId = this.props.gruppoId;
    getGruppo(gruppoId)
      .then((result) => {
        let record = Object.assign({}, this.state.consulente);
        record.gruppoId = result.id;
        this.setState({
          consulente: record,
          gruppo: result,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  validateForm = () => {
    const record = this.state.consulente;
    const validationErrors = {
      email: this.errorForField('email', record.email),
      // A consultant who signs in with Microsoft has no password to validate.
      password: record.passwordEnabled
        ? this.errorForField('password', record.password)
        : '',
      confirmPassword: record.passwordEnabled
        ? this.errorForField('confirmPassword', record.confirmPassword)
        : '',
    };
    this.setState({ validationErrors });
    return Object.values(validationErrors).some((errore) => errore.length > 0);
  };

  // The message one field carries, '' when it is valid. It returns rather than
  // writing state, so validateForm can read every answer in the same pass that
  // computed it.
  errorForField = (key, value) => {
    switch (key) {
      case 'email':
        if (value.length === 0) {
          return "Inserire l'indirizzo email";
        }
        return validator.isEmail(value)
          ? ''
          : "L'indirizzo email inserito non è valido";
      case 'password':
        return value.length >= 8
          ? ''
          : 'Inserire una password di almeno 8 caratteri';
      case 'confirmPassword':
        if (value.length === 0) {
          return 'Ripetere la password';
        }
        return value === this.state.consulente.password
          ? ''
          : 'Le due password non corrispondono';
      default:
        return '';
    }
  };

  handleChanges = (event) => {
    let consulente = this.state.consulente;
    consulente[event.target.name] = event.target.value;
    let validationErrors = this.state.validationErrors;
    for (let key in validationErrors) {
      if (event.target.name === key) {
        validationErrors[key] = '';
        break;
      }
    }
    this.setState({
      consulente,
      changesNotSaved: true,
      submitDisabled: false,
      validationErrors,
    });
  };

  handleAuthTypeChange = (selected) => {
    const isLocal = selected === AUTH_TYPES.LOCAL;

    this.setState((prevState) => ({
      consulente: {
        ...prevState.consulente,
        passwordEnabled: isLocal,
        oauthEnabled: !isLocal,
        ...(isLocal ? {} : { password: '', confirmPassword: '' }),
      },
      validationErrors: {
        ...prevState.validationErrors,
        password: '',
        confirmPassword: '',
      },
      changesNotSaved: true,
      submitDisabled: false,
    }));
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const invalidForm = this.validateForm();
    if (!invalidForm) {
      this.setState({
        loading: true,
      });
      registerConsulente(false, this.state.consulente)
        .then((result) => {
          this.setState({
            loading: false,
            disabledForm: true,
            changesNotSaved: false,
          });
          reportError(
            'Il nuovo consulente è stato registrato con successo.',
            'Registrazione effettuata',
          );
        })
        .catch((error) => {
          // A refused registration created nothing, so the form stays open on
          // what was typed: the form is locked only once a consultant exists.
          this.setState({
            loading: false,
          });
          reportApiError(error);
        });
    }
  };

  render() {
    return (
      <Container maxWidth={false} style={styles.root}>
        {this.state.loading ? (
          <SpinnerComponent size={24} />
        ) : this.state.gruppo.id === null ? (
          <Typography variant="body1" style={styles.texts}>
            Caricamento dati fallito.
          </Typography>
        ) : (
          <Fragment>
            <Typography variant="h4" style={styles.texts}>
              Registra un nuovo consulente per il gruppo{' '}
              <Typography
                component="span"
                variant="h4"
                style={styles.groupName}
              >
                {this.state.gruppo.nome}
              </Typography>
            </Typography>
            <Container maxWidth="md" style={styles.root}>
              <FormRegistrazioneConsulenteGruppo
                consulente={this.state.consulente}
                validationErrors={this.state.validationErrors}
                onAuthTypeChange={this.handleAuthTypeChange}
                onChange={this.handleChanges}
                onSubmit={this.handleSubmit}
                disabled={this.state.disabledForm}
                submitDisabled={this.state.submitDisabled}
                changesNotSaved={this.state.changesNotSaved}
              />
            </Container>
          </Fragment>
        )}
      </Container>
    );
  }
}

RegistraConsulenteGruppoPage.propTypes = {
  gruppoId: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
};
